import { useSelector } from 'react-redux'
import { LanguageUtils, Utils } from '@pbt/pbt-ui-components'

import AccentLabel from '~/components/common/labels/AccentLabel'
import { getInventoryOrderShipmentStatus } from '~/store/reducers/constants'

export interface InventoryOrderStatusLabelProps {
  statusId: string
}

const InventoryOrderStatusLabel = ({
  statusId,
}: InventoryOrderStatusLabelProps) => {
  const InventoryOrderStatuses = useSelector(getInventoryOrderShipmentStatus)
  const status = Utils.findById(statusId, InventoryOrderStatuses)

  if (!status) {
    return null
  }

  return (
    <AccentLabel
      color={status.color}
      colorVariant={status.colorVariant}
      id={status.id}
      name={LanguageUtils.getTranslatedFieldName(status)}
    />
  )
}

export default InventoryOrderStatusLabel
